import React, { useEffect, useCallback, useState } from "react";
import Logo from "../Assets/Logo";
import { useNavigate, useParams } from "react-router-dom";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Helmet } from "react-helmet";
import favicon from "../Assets/Favicon.png";
import Headers from "../Common/Headers";
import Post from "../../../Apis/backlink/Post";
import Get from "../../../Apis/backlink/Get";
import LinkTable from "../../utils/LinkTable/LinkTable";
import loadingGif from "../Assets/loading.gif";
import "./style.css";
import { getAPIUrlBM } from "../../../utils/config";
import KeyboardArrowDownIcon from "../Assets/KeyboardArrowDownIcon";
import KeyboardArrowUpIcon from "../Assets/KeyboardArrowUpIcon";
// import ogImage from "../Assets/og_backLink.png";
import TablePagination from "../../utils/TablePagination/TablePagination";

function PublicDashBoard() {
  const [searched, setSearched] = useState(null);
  const [isloading, setIsloading] = useState(true);
  const [links, setLinks] = useState();
  const [reasonOfErrorFilter, setReasonOfErrorFilter] = useState([
    { name: "Page 4XX", value: "Page 4" },
    { name: "Page 5XX", value: "Page 5" },
    { name: "Anchor text almost matched", value: "Anchor text almost matched" },
    { name: "Rel tag not matched", value: "Rel tag not matched" },
    { name: "Anchor text not matched", value: "Anchor text not matched" },
    { name: "Reltag found", value: "Reltag found" },
    { name: "Anchor text found", value: "Anchor text found" },
    {
      name: "Domain present, exact link not found",
      value: "Domain present, exact link not found",
    },
    { name: "link_to not in link_from", value: "link_to not in link_from" },
    {
      name: "Internal error. Note able to render site.",
      value: "Internal error. Note able to render site.",
    },
    { name: "Link Timeout", value: "Link Timeout" },
    { name: "link_from invalid", value: "link_from invalid" },
  ]);
  const params = useParams();
  const { list_name, list_id } = params;
  const navigate = useNavigate();

  const [statusArray, setStatusArray] = useState([]);
  const [reasonOfErrorArray, setReasonOfErrorArray] = useState([]);
  const [expandAll, setExpandAll] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [brandData, setBrandData] = useState({});

  const handleStatus = async (operation, value) => {
    if (operation) setStatusArray([...statusArray, value]);
    else {
      var newStatusArr = statusArray.filter((val) => val != value);
      setStatusArray(newStatusArr);
    }
  };
  const handleReasonForError = async (operation, value) => {
    if (operation) setReasonOfErrorArray([...reasonOfErrorArray, value]);
    else {
      var newReasonOfErrorArray = reasonOfErrorArray.filter(
        (val) => val != value,
      );
      setReasonOfErrorArray(newReasonOfErrorArray);
    }
  };

  const requestSearch = async () => {
    try {
      setIsloading(true);
      const url = getAPIUrlBM();
      const res = await Post(
        url + `/searchpubliclink/?page=${currentPage}&size=${rowsPerPage}`,
        {
          search: searched,
          listId: list_id,
        },
      );
  
      if (currentPage === 1) setTotalRows(parseInt(res.count));
      setLinks(res.data2);
      setIsloading(false);
      
    } catch (error) {
      console.log(error)
    }
  };

  console.log({links})

  const getPublicLinks = async () => {
    try {
      // setIsloading(true);
      setLinks([]);
      const url = getAPIUrlBM();
      const reqBody = {
        search: searched ? searched : "",
      };
      reqBody.listId = list_id;
      if (statusArray.length !== 0) reqBody.status = statusArray;
      if (reasonOfErrorArray.length !== 0)
        reqBody.reasonForerror = reasonOfErrorArray;
  
      const res = await Post(
        url + `/getpubliclinks/?page=${currentPage}&size=${rowsPerPage}`,
        reqBody,
      );
  
      if (currentPage === 1) setTotalRows(parseInt(res.count));
      setLinks(res.data2);
    } catch (error) {
      console.log(error)
    }
  };

  // const getReasonOfErrors = async () => {
  //   const url = getAPIUrlBM();
  //   const res = await Get(url + "/getreasonoferrors");
  //   setReasonOfErrorFilter(res.data);
  // };

  useEffect(() => {
    getPublicLinks();
  }, [rowsPerPage, currentPage, statusArray, reasonOfErrorArray]);

  useEffect(() => {
    (async () => {
      try {
        const url = getAPIUrlBM();
        const res = await Get(url + `/getBranding/${list_id}`);
        if (res.status === "success") {
          setBrandData(res.data[0]);
        }
      setIsloading(false);
      } catch (error) {
        console.log(error)
      }
    })()
  }, [list_id])

  
  const HeaderNav = useCallback(() => {
    return (
      <div className="public-header">
        <div className="public-logoDiv" onClick={() => navigate("/backlink")}>
          <div className="public-logoContainer">
              {brandData?.logoUrl ? (
                    <img src={brandData?.logoUrl} alt="logo" className="logoDiv h-100"  />
                  ) : <Logo />
              }
          </div>
          <div 
            className="public-heading" 
            style={brandData  ? {
              color: brandData.brandColor,
              fontFamily: brandData.fontFamily,
              fontSize: brandData.fontSize + 'px',
            } : {}}
            >{brandData?.brandName || "BackLink Checker"}</div>
        </div>
      </div>
    );
  }, [brandData])

  const header = {
    heading: list_name,
    link: "https://www.google.co.in/",
    subHeading: "Check your backlinks",
    description:
      "Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively.",
    isSubHeading: true,
  };

  return (
    <div>
      <Helmet>
        <title>Lists - Backlink Checker</title>
        <meta
          name="description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <meta property="og:title" content="Lists - Backlink Checker" />
        <link rel="icon" type="image/png" href={brandData?.faviconUrl || favicon} sizes="16x16" />
        <meta
          property="og:description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
      </Helmet>
      {!isloading ? (
        <>
          <div className="subMainContainer">
            <HeaderNav />
            <div className="dashboardContainer">
              <Headers header={header} />

              <div className="linkBody">
                <div>
                  <p className="heading">Filter & Search BackLink</p>
                  <div className="linkFilterSection">
                    <div className="filterItem2">
                      <p className="subHeader">Status</p>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              style={brandData ? {color : brandData.brandColor} : {}}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Ok")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Ok</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              style={brandData ? {color : brandData.brandColor} : {}}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Present")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Present</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              style={brandData ? {color : brandData.brandColor} : {}}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Not Checked")
                              }
                            />
                          }
                          label={
                            <span className="labelCheckbox">Not checked</span>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              style={brandData ? {color : brandData.brandColor} : {}}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Absent")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Absent</span>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="success"
                              style={brandData ? {color : brandData.brandColor} : {}}
                              onChange={(e) =>
                                handleStatus(e.target.checked, "Error")
                              }
                            />
                          }
                          label={<span className="labelCheckbox">Error</span>}
                        />
                      </FormGroup>
                    </div>
                    <div className="filterItem3">
                      <p className="subHeader">Reason of error</p>
                      <FormGroup>
                        <div className="grid_Filters">
                          {reasonOfErrorFilter?.map((errType, index) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="success"
                                  style={brandData ? {color : brandData.brandColor} : {}}
                                  onChange={(e) =>
                                    handleReasonForError(
                                      e.target.checked,
                                      errType.value,
                                    )
                                  }
                                  key={index}
                                />
                              }
                              label={
                                <span className="labelCheckbox">
                                  {errType.name}
                                </span>
                              }
                            />
                          ))}
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <div>
                    <p className="subHeader"> Search</p>
                    <input
                      type="text"
                      value={searched}
                      placeholder="Search a specific item - ‘Link From’ or ‘Link To’ URL"
                      className="searchField"
                      onChange={(e) => setSearched(e.target.value)}
                    />
                    <button
                      onClick={() => {
                        if (currentPage === 1) getPublicLinks();
                        else setCurrentPage(1);
                      }}
                      className="successButton"
                      style={brandData ? {backgroundColor : brandData.brandColor} : {}}
                    >
                      Search
                    </button>
                  </div>
                </div>

                <div className="linkTable px-4">
                    <div className="gridContainerInTable">
                        <div className="gridItemInTable gridItemInTableHeader">
                          Bulk
                        </div>{" "}
                        <div className="gridItemInTable gridItemInTableHeader" >Link ID</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Added On</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Index Status</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Link From Page</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Link to URL</div>
                        <div className="gridItemInTable gridItemInTableHeader" >List Included in</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Rel Tag</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Anchor</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Notes</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Error Code</div>
                        <div className="gridItemInTable gridItemInTableHeader" >DA</div>
                        <div className="gridItemInTable gridItemInTableHeader" >Spam Score</div>
                        <div className="gridItemInTable gridItemInTableHeader"  style={{ paddingTop: "28px" }}>
                          Status
                          <br />
                          <div onClick={() => setExpandAll(!expandAll)}>
                            <span
                              style={{
                                marginRight: "5px",
                                color: "#5541D7",
                                fontSize: "12px",
                                cursor: "pointer",
                              }}
                            >
                              {expandAll
                                ? "Collapse All Logs"
                                : "Expand All Logs"}
                            </span>

                            {expandAll ? (
                              <KeyboardArrowUpIcon color="#5541D7" />
                            ) : (
                              <KeyboardArrowDownIcon  color="#5541D7" />
                            )}
                          </div>
                        </div>
                    </div>

                      {links?.length !== 0 ? (
                        links?.map((link, index) => {
                          return (
                            <LinkTable
                              key={index}
                              data={{
                                ...link,
                                link_to: link?.link_to
                                  .replace("https://", "")
                                  .replace("http://", ""),
                                link_from: link?.link_from
                                  .replace("https://", "")
                                  .replace("http://", ""),
                              }}
                              id={link?.link_Id}
                              open={index === 0}
                              showDelete={false}
                              expandAll={expandAll}
                            />
                          );
                        })
                      ) : links?.length === 0 &&
                        statusArray.length === 0 &&
                        reasonOfErrorArray.length === 0 &&
                        searched === null ? (
                        <>
                            <div
                              style={{
                                gridColumn: "1/9",
                              }}
                            >
                          <div className="centerDiv">
                            <p className="noData">List is empty</p>
                          </div>
                        </div>
                        </>
                      ) : (
                        <div
                        style={{
                          gridColumn: "1/9",
                        }}
                      >
                        <div className="centerDiv">
                          <p className="noData">No result found!!</p>
                        </div>
                      </div>
                      )}               
                </div>
              </div>
            </div>
          </div>

          <TablePagination
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRows={totalRows}
            bgColor={"#f9fafb"}
          />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <img
            style={{
              width: "100vw",
              height: "100vh",
            }}
            alt=""
            src={loadingGif}
          />
        </div>
      )}
    </div>
  );
}

export default PublicDashBoard;
